import { Button, Result } from 'antd';
import type { LocaleKey } from './context';

// 仅用于语言资源或币种元数据无法加载的启动边界；不进入 Intl，也不供业务页面回退。
// 两句沿用原有三语故障/重试文案，保证断网时仍能启动重试动作。
const STARTUP_TEXT = {
  'zh-HK': {
    network: '網絡異常，請檢查網絡後重試',
    retry: '重試',
  },
  'zh-CN': {
    network: '网络异常，请检查网络后重试',
    retry: '重试',
  },
  'en-US': {
    network: 'Network error. Please check your connection and try again',
    retry: 'Retry',
  },
};

export default function StartupFailure({
  locale,
  onRetry,
}: {
  locale: LocaleKey;
  onRetry: () => void;
}) {
  return (
    <Result
      status="error"
      title={STARTUP_TEXT[locale].network}
      extra={
        <Button type="primary" onClick={onRetry}>
          {STARTUP_TEXT[locale].retry}
        </Button>
      }
    />
  );
}
